// extracted by mini-css-extract-plugin
export default {"access-denied-wrapper":"AccessDenied_access-denied-wrapper__rnSdS","message":"AccessDenied_message__68s9L"};